import core from '@gin-betting/core';

import moduleLocator from 'moduleLocator';
import { Modules } from '../../../types';

const {
    hocs: { withAsyncLoad },
    utils: { measureTime },
} = core;

export async function loadStreamModule(): Promise<Modules['stream']> {
    return import(/* webpackChunkName: "stream-module" */ '../index').then(
        module => {
            measureTime('streamModuleLoaded');
            moduleLocator.set('stream', module);

            return module;
        }
    );
}

export const AsyncStream = withAsyncLoad({
    loader: loadStreamModule,
    loading: () => null,
    componentToRender: 'Stream',
});

export const AsyncPersistentStream = withAsyncLoad({
    loader: loadStreamModule,
    loading: () => null,
    componentToRender: 'PersistentStream',
});
